import BaseService from './BaseService'

export interface IContactByBusinessByIdPayload {
  locationId: string
  businessId: String,
  limit : number
  skip :number,
  query ?:string
}

export interface IAddBusinessToContacts {
  ids : string[],
  locationId : string,
  businessId :string | null
}

export interface IFetchContactsWithoutBusinessId {
  locationId: string
  businessId :string
  query ? :string
  size ?: string
  skip ?: string
}


export interface IFetchContactsByIds {
  locationId: string
  ids: string[]
}

class ContactService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getDeleted = (locationId: string, startAt?: string) =>
    this.requests.get(
      `/${locationId}/deleted/${startAt ? '?startAt=' + startAt : ''}`
    )
  deleteContacts = (contacts: string[]) =>
    this.requests.post(`/bulk/delete/`, { contacts })
  restoreContacts = (contacts: string[], locationId: string) =>
    this.requests.post(`/bulk/restore/`, { contacts, locationId })
  update = (id: string, data: { [key: string]: any }) =>
    this.requests.put(`/${id}?version=14-05-22`, data)
  create = (data: { [key: string]: any }) => this.requests.post(`/?version=14-05-22`, data)
  getAudit = (id: string) => this.requests.get(`/${id}/audits`)
  read = (id: string) => this.requests.get(`/${id}`)
  searchDuplicateByPhone = (locationId: string, number: string) => this.requests.get(`/search/duplicate?locationId=${locationId}&number=${encodeURIComponent(number)}`)
  validateEmail = (id: string) => this.requests.post(`/${id}/validateEmail/`, {})
  syncOAuth = (id: string) => this.requests.post(`/${id}/syncOAuth/`, {})
  getByLocationId = (id: string) => this.requests.get(`/?locationId=${id}`)
  Notes = {
    create: (contactId: string, data: { [key: string]: any }) =>
      this.requests.post(`/${contactId}/notes/`, data),
    read: (contactId: string, noteId: string) =>
      this.requests.get(`/${contactId}/notes/${noteId}`),
    update: (contactId: string, noteId: string, data: { [key: string]: any }) =>
      this.requests.put(`/${contactId}/notes/${noteId}`, data),
    delete: (contactId: string, noteId: string) =>
      this.requests.delete(`/${contactId}/notes/${noteId}`),
    list: (contactId: string) => this.requests.get(`/${contactId}/notes/`),
    restore: (noteId: string, contactId: string, forceRestore:boolean) =>
    this.requests.put(`/${contactId}/notes/${noteId}/restore`,{forceRestore:forceRestore}),
  }
  Tasks = {
    create: (contactId: string, data: { [key: string]: any }) =>
      this.requests.post(`/${contactId}/tasks/`, data),
    read: (contactId: string, taskId: string) =>
      this.requests.get(`/${contactId}/tasks/${taskId}`),
    update: (contactId: string, taskId: string, data: { [key: string]: any }) =>
      this.requests.put(`/${contactId}/tasks/${taskId}`, data),
    delete: (contactId: string, taskId: string) =>
      this.requests.delete(`/${contactId}/tasks/${taskId}`),
    list: (contactId: string) => this.requests.get(`/${contactId}/tasks/`),
    restore: (taskId: string, contactId: string, forceRestore:boolean) =>
    this.requests.put(`/${contactId}/tasks/${taskId}/restore`,{forceRestore:forceRestore}),
  }
  SmartList = {
    create: (data: { [key: string]: any }) =>
      this.requests.post(`/smartlist/`, data),
    read: (id: string) =>
      this.requests.get(`/smartlist/${id}`),
    delete: (smartListId: string) =>
      this.requests.delete(`/smartlist/${smartListId}`),
    update: (smartListId: string, data: { [key: string]: any }) =>
      this.requests.put(`/smartlist/${smartListId}`, data),
    list: (locationId: string, includeGlobals: boolean = false, userId?: string) =>
      this.requests.get(`/smartlist/search?locationId=${locationId}${userId ? '&userId=' + userId : ''}${includeGlobals ? '&globals=' + includeGlobals : ''}`),
    searchContacts: (data: any) =>
      this.requests.post(`/search`, data),
    searchContactsV2: (data: any) =>
      this.requests.post(`/search/2`, data),
    searchContactsByIds: (data: IFetchContactsByIds) =>
      this.requests.post(`/search/ids/es`, data),
  }
  Businesses={

    searchContactsByBusinessId : (payload :IContactByBusinessByIdPayload) =>
        this.requests.get(
        `/business/${payload.businessId}`,
        {
          params: {
            locationId: payload.locationId,
            limit : payload.limit,
            skip : payload.skip,
            count :true,
            query : payload.query,
          },
        }
      ),
      fetchContactsWithoutBusinessId : (payload :IFetchContactsWithoutBusinessId) =>
      this.requests.get(
      `/search/business`,
      {
        params: {
          locationId: payload.locationId,
          businessId: payload.businessId,
          query : payload.query,
          size : payload.size,
          skip : payload.skip
        },
      }
    )
    }
    Bulk={
      addBusinessIdToContacts : (payload : IAddBusinessToContacts)=>
        this.requests.post(
          `/bulk/business`,
          {

              ...payload
            ,
          }
        )


    }

  deleteSmartlistContacts = (
    contacts: string[],
    smartList: any,
    locationId: string
  ) =>
    this.requests.post(`/bulk/smartlist/delete/`, {
      contacts,
      smartList,
      locationId,
    })
  addTag = (contactId:string,tags:string[])=>this.requests.post(`/${contactId}/tags`, { tags })
  removeTag = (contactId:string,tags:string[])=>this.requests.delete(`/${contactId}/tags`, {  data : {tags} })
  addTags = (tags:string[],note:string,contacts: string[], smartList: any, locationId: string) =>
    this.requests.post(`/bulk/tags/add`, { contacts, smartList, locationId, note, tags })
  removeTags =(tags:string[],note:string,contacts: string[], smartList: any, locationId: string) =>
    this.requests.post(`/bulk/tags/remove`, { contacts, smartList, locationId, note, tags })
  getImportLog = (importId: string,skip:number,limit:number) => this.requests.get(`/bulk/import/${importId}/logs?skip=${skip}&limit=${limit}`)
  revertImport = (importId: string) => this.requests.get(`/bulk/import/${importId}/revert`)
  restoreBulkdelete = (bulkRequestId: string) => this.requests.get(`/bulkRequests/${bulkRequestId}/restore`)
  cancelImport = (importId: string) => this.requests.post(`/bulk/import/${importId}/status`, {"status":"cancelled"})
  import = (data: { [key: string]: any }) => this.requests.post(`/bulk/import/`, data)
  merge = (data: { [key: string]: any }) => this.requests.post(`/merge/`, data)
  restoreContact = (id: string,) => this.requests.put(`/${id}/restore`,{})
  getContactDetails = (data: {
    allDetails: boolean,
    locationId: string,
    contactIds:string[]
  }) => this.requests.post('/search/ids/es',{locationId:data.locationId,ids:data.contactIds})

}

const instance = new ContactService(BaseService.servicesConfig.Contacts)

export default instance
